<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
					<el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加郵件</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button>

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="標題" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索標題"></el-input>
						</el-form-item>

						<el-form-item label="編號" class="mb-0">
							<el-input size="small" v-model="from.email_no" placeholder="搜索編號"></el-input>
						</el-form-item>

						<el-form-item label="接收人" class="mb-0">
							<el-input size="small" v-model="from.in_name" placeholder="搜索接收人"></el-input>
						</el-form-item>
					
						<el-form-item label="發送類型">
							<el-select v-model="from.in_type" size="small" placeholder="請選擇發送類型">
                                <el-option label="全部" :value="-1"></el-option>
								<!-- <el-option label="機構" :value="2"></el-option> -->
								<el-option label="學校" :value="3"></el-option>
								<el-option label="學生" :value="4"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="郵件類型">
							<el-select v-model="from.email_type" size="small" placeholder="請選擇郵件類型">
                                <el-option label="全部" :value="-1"></el-option>
								<el-option label="普通郵件" :value="1"></el-option>
								<el-option label="題目反饋" :value="2"></el-option>
								<el-option label="比賽郵件" :value="3"></el-option>
								<el-option label="訂單郵件" :value="4"></el-option>
								<el-option label="贈送禮物" :value="5"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="是否已讀">
							<el-select v-model="from.reply_status" size="small" placeholder="請選擇發送類型">
                                <el-option label="全部" :value="-1"></el-option>
								<!-- <el-option label="機構" :value="2"></el-option> -->
								<el-option label="未回覆" :value="1"></el-option>
								<el-option label="已讀" :value="2"></el-option>
								<el-option label="未讀" :value="3"></el-option>
							</el-select>
						</el-form-item>
					
					
					
						<el-form-item label="發送時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">
				</el-table-column>
		
				
				<el-table-column align="center" width="140" prop="email_no" label="編號">
				</el-table-column>
			
				
				<el-table-column align="center" prop="title" label="發送標題">
								<template slot-scope="scope">
									<div v-if="scope.row.title.length > 20">
										{{ scope.row.title.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.title }}
									</div>
								</template>
					</el-table-column>
				
				

				<el-table-column align="center" width="100" prop="content" label="郵件內容">
						<template slot-scope="scope">
							<div slot="reference" style="cursor: pointer;" class="name-wrapper" @click="openDialog(scope,1)">
								<el-tag size="medium">查看</el-tag>
							</div>
						</template>
				</el-table-column>
				
				
				<el-table-column align="center" width="100" prop="status"  label="發送類型">
					<template slot-scope="v">
						<span class="text-success" v-if="v.row.in_type==4">學生</span>
						<span class="text-warning" v-if="v.row.in_type==3">學校</span>
					</template>
				</el-table-column>

				<el-table-column align="center" width="120" prop="type"  label="郵件類型">
					<template slot-scope="v">
						<el-tag v-if="v.row.type==1" type="info" size="small">普通郵件</el-tag>
						<el-tag v-if="v.row.type==2" type="warning" size="small">題目反饋</el-tag>
						<el-tag v-if="v.row.type==3" type="success" size="small">比賽郵件</el-tag>
						<el-tag v-if="v.row.type==4" type="danger" size="small">訂單郵件</el-tag>
						<el-tag v-if="v.row.type==5" type="primary" size="small">贈送禮物</el-tag>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="name" width="300" label="接收人">
					<template slot-scope="scope">
						<span>
							<el-tag v-if="scope.row.in_type == 3" type="warning">{{scope.row.school_data.name}}</el-tag>
							<el-tag v-if="scope.row.in_type == 4" type="success">{{scope.row.user_data.name}}</el-tag>
						</span>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" width="100" prop="reply_content" label="回覆郵件">
						<template slot-scope="scope">
								<div v-if="scope.row.is_reply == 1" slot="reference" style="cursor: pointer;" class="name-wrapper" @click="openDialog(scope,2)">
									<el-tag size="medium">查看</el-tag>
								</div>
								<div v-else slot="reference">
									未回覆
								</div>
						</template>
				</el-table-column>
				

				
				<el-table-column align="center" width="100" prop="status"  label="是否已讀">
					<template slot-scope="v">
						<span v-if="v.row.is_reply_status==2">未回覆</span>
						<span class="text-success" v-if="v.row.is_reply_status==1">已讀</span>
						<span class="text-danger" v-if="v.row.is_reply_status==0">未讀</span>
					</template>
				</el-table-column>


				<el-table-column align="center" prop="create_time" width="180" label="發送時間">
					
				</el-table-column>
				
			
				
				

				<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,3)">操作</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>


				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'添加郵件':'修改郵件'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單內容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
		
				<el-form-item  label="發送類型"  prop="sendtype">
					 <el-radio-group @change="changeType" v-model="form.all_type" :disabled="editIndex>0?true:false">
						<el-radio :label="4">指定學生</el-radio>
					    <el-radio :label="3">指定學校</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="郵件類型" prop="email_type">
					<el-select v-model="form.email_type" :disabled="editIndex>0?true:false" size="small" style="width: 85%;" placeholder="請選擇郵件類型">
						<el-option label="普通郵件" :value="1"></el-option>
						<el-option label="題目反饋" :value="2"></el-option>
						<el-option label="比賽郵件" :value="3"></el-option>
						<el-option label="訂單郵件" :value="4"></el-option>
						<el-option label="贈送禮物" :value="5"></el-option>
					</el-select>
				</el-form-item> 
			
                <el-form-item v-show="form.all_type==4" label="選擇學生" prop="appoint_id">
                    <el-select
                        multiple
                        :disabled="editIndex>0?true:false" size="small" style="width: 85%;"
                        v-model="form.appoint_id"
						filterable
						remote
						reserve-keyword
						placeholder="請輸入關鍵詞:學生編號 - 學生名稱 - 學校 - 年級"
						:remote-method="remoteMethod"
						:loading="loading">
						<el-option
						v-for="item in userOptions"
						:key="item.id"
						:label="item.str_name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

                <el-form-item v-show="form.all_type==3" label="選擇學校" prop="appoint_id">
                    <el-select
                        :disabled="editIndex>0?true:false" size="small" style="width: 85%;"
						v-model="form.appoint_id"
						filterable
						remote
						reserve-keyword
						placeholder="請輸入關鍵詞:學校編號 - 學校地區 - 學校名稱"
						:remote-method="remoteMethodSchool"
						:loading="loading">
						<el-option
						v-for="item in schoolOptions"
						:key="item.id"
						:label="item.str_name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="發送標題" prop="title">
					<el-input type="text" v-model="form.title" 
					placeholder="發送標題" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				<el-form-item label="發送內容" prop="content">
					<el-input type="textarea" :rows="8" v-model="form.content" class="content_huan"
					placeholder="發送內容" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item v-show="form.all_type==4"  label="鑽石" prop="diamond">
						<el-input type="number" v-model="form.diamond"  :disabled="editIndex>0?true:false"
						placeholder="鑽石數量" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>
					
					<el-form-item  v-show="form.all_type==4"  label="金幣" prop="money">
						<el-input type="number" v-model="form.money" :disabled="editIndex>0?true:false"
						placeholder="金幣數量" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>

					<el-form-item v-show="form.all_type==4"  label="贈送禮物" prop="gift_id">
										<el-select v-model="form.gift_id" style="width: 85%;" :disabled="editIndex>0?true:false" multiple filterable placeholder="請選擇">
											<el-option
											v-for="item in user_gift"
											:key="item.id"
											:label="item.type_name"
											:disabled="item.disabled"
											:value="item.id">
											</el-option>
										</el-select>
									</el-form-item>
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" :loading="submitLoading" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false"  :visible.sync="dialogTitleVisible" title="發送標題">
			<p>{{ fullTitle }}</p>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"  
			:visible.sync="dialogVisible" 
			:width="layout.is_phone ? '90%' : '70%'" 
			title="郵箱信息" 
			@close="closeDialog"
			>
			<!-- 郵件信息头部 -->
			<div v-if="dialogType == 1" class="dialog-header">
				<div class="email-info">
				<p><strong>標題：</strong> {{ emailTitle }}</p>
				<p><strong v-if="is_reply == 1">發送人：</strong><strong v-if="is_reply == 2">回覆人：</strong> {{ senderName }}</p>
				<p><strong>發送時間：</strong> {{ sendTime }}</p>
				</div>
			</div>
			
			
			<!-- 郵件内容 -->
			<div v-html="dialogContent" class="dialog-content"></div>
			
			<!-- 弹框底部 -->
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="reply(scope)" size="mini" type="success">回覆</el-button> -->
				<el-button @click="reply(replyData)" v-if="is_reply == 2" type="success">回 覆</el-button>
				<el-button @click="closeDialog">關 閉</el-button>
			</span>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"  
			title="回覆消息" 
			:visible.sync="createReplyModel" 
			top="5vh" 
			:width="layout.is_phone ? '90%' : '80%'" 
			class="custom-dialog"
			>

			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone ? '80px' : '100px'" :label-position="layout.is_phone ? 'top' : 'left'">
			<template> 
				
						<el-descriptions v-if="form.in_type == 4" class="margin-top" title="學生信息" :column="3" style="margin-bottom: 30px;" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								姓名
							</template>
							{{ form.user_name }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								英文
							</template>
							{{ form.name_en }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								電話
							</template>
							{{ form.phone }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-message"></i>
								郵箱
							</template>
							{{ form.email }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-school"></i>
								學校
							</template>
							{{form.school}}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-collection"></i>
								年級
							</template>
							{{form.g_name}}
							</el-descriptions-item>
						</el-descriptions>

						<el-descriptions v-if="form.in_type == 3" class="margin-top" title="學校信息" :column="3" style="margin-bottom: 30px;" border>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								名稱
							</template>
							{{ form.school_name }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								英文
							</template>
							{{ form.school_name_en }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								校長
							</template>
							{{ form.rector }}
							</el-descriptions-item>
							
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								電話
							</template>
							{{ form.school_phone }}
							</el-descriptions-item>
							
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-message"></i>
								地址
							</template>
							{{ form.local }}
							</el-descriptions-item>
						</el-descriptions>


					<el-descriptions class="margin-top" title="郵件信息" :column="3" style="margin: 20px 0;">
						<el-descriptions-item label="编號"> {{ form.email_no }}</el-descriptions-item>
						<el-descriptions-item label="發送人">{{ form.in_type == 4 ? form.user_name : form.school_name }}</el-descriptions-item>
						<el-descriptions-item label="發送時間">
							{{ form.create_time }}
						</el-descriptions-item>
						
						<el-descriptions-item label="標題" :contentStyle="{'width': '80%'}">
							<!-- 限制高度並添加滾動條 -->
							
							{{ form.title }}
							
						</el-descriptions-item>
						<el-descriptions-item label="郵件内容"  :contentStyle="{'width': '90%'}">
							<!-- 限制高度並添加滾動條 -->
							<div class="email-content">
							{{ form.content }}
							</div>
						</el-descriptions-item>
					</el-descriptions>
			</template>
				<!-- 顶部信息展示区 -->
			

				<!-- 回复標題輸入 -->
				<el-form-item label="回覆標題" prop="reply_title">
				<el-input 
					type="text" 
					v-model="form.reply_title"
					maxlength="50"
					show-word-limit
					placeholder="回覆標題"
					clearable 
					size="small" 
					class="form-input"
				/>
				</el-form-item>

				<!-- 回复内容輸入 -->
				<el-form-item label="回覆内容" prop="reply_content">
				<el-input 
					type="textarea" 
					:rows="3" 
					v-model="form.reply_content"
					show-word-limit
					placeholder="回覆内容"
					clearable 
					size="small" 
					class="form-input"
				/>
				</el-form-item>
			</el-form>

			<!-- 底部按钮 -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="createReplyModel = false">取消</el-button>
				<el-button type="primary" :loading="submitLoading" @click="submit">確定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				dialogVisible: false,      // 控制對話框顯示
				dialogContent: '' ,         // 存储當前对话框的内容

				emailTitle: '' ,         // 
				senderName: '' ,         // 
				sendTime: '' ,         // 
				dialogType:1,

				dialogTitleVisible: false,
				fullTitle: '',
                rules: {
                    title: [{ required: true, message: "標題不能為空", trigger: 'blur' }],
                    content: [{ required: true, message: "內容不能為空", trigger: 'blur' }],
                    appoint_id: [{ required: true, message: "請選擇對象", trigger: 'change' }],
                    email_type: [{ required: true, message: "請選擇郵件類型", trigger: 'change' }],
                },
				createModel: false,
				createReplyModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					email_no:'',
					content:'',
					in_name:'',
					in_type:-1,
					all_type:-1,
					reply_status:-1,
					type:-1,
					email_type:-1,
					time: [],
				},
				model_title: 'Notice',
				auth_val: 'Notice',
				preUrl: "data/emailList", //列表地址
				addUrl: "data/addEmail", //添加/修改地址
				delAllUrl: "data/delEmailAll", //批量删除地址
				delUrl: "data/delEmail", //删除單条地址
				editStatusUrl: "data/editStatusReplyEmail", //修改狀態地址
				tableData: [],
                form: {
                    id: 0,
                    title:'',
                    content:"",
                    appoint_id:[],
                    diamond:0,
                    money:0,
                    gift_id:[],
                    all_type:4,
                    email_type:1,
                },
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				user_gift: [],
				inst_list: [],
				user_list: [],
				is_reply:1,
				userOptions: [],
				schoolOptions: [],
				userValue: [],
				loading: false,
				submitLoading: false,
			}
		},
		
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['user_list','school_list','user_gift']);
		},
		methods: {
			reply(e){
				// 初始化表單數據
				this.form = {
					id: e.row.id,
					in_id: e.row.in_id,
					in_type: e.row.in_type,
					appoint_id:  e.row.in_id,
					is_reply:2,

					school_id: e.row.school_data.id,
					school_name: e.row.school_data.name,
					school_name_en: e.row.school_data.name_en,
					school_phone: e.row.school_data.phone,
					local: e.row.school_data.local,
					rector: e.row.school_data.rector,

					user_name: e.row.user_data.name,
					name_en: e.row.user_data.name_en,
					phone: e.row.user_data.phone,
					email: e.row.user_data.email,
					school: e.row.user_data.school_name,
					g_name: e.row.user_data.grade_name,

					title: e.row.reply_title,
					email_no: e.row.reply_no,
					create_time: e.row.reply_time,
					content: e.row.reply_content,
					
					reply_content: '',
					reply_title: 'RE:' + e.row.reply_title,
				};

				this.editIndex = e.row.id;
				this.createReplyModel = true;
			},
			remoteMethod(query) {
				if (query !== '') {
					this.loading = true;
					this.axios.post('/admin/data/getUserList', {
						value: query,
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						this.userOptions = all.data;
						this.loading = false;
					}).catch(err => {
						// 失敗
						this.userOptions = [];
						this.loading = false;
					})
				} else {
					this.userOptions = [];
					this.loading = false;
				}
			},
			openDialog(e,type) {
				let row = e.row
				if(type == 2){
					this.dialogContent = row.reply_content; // 设置要顯示的 HTML 内容
					this.emailTitle = row.reply_title; // 设置要顯示的 HTML 内容
					this.senderName = row.reply_name; // 设置要顯示的 HTML 内容
					this.sendTime = row.reply_time; // 设置要顯示的 HTML 内容
				}else{
					this.dialogContent = row.content; // 设置要顯示的 HTML 内容
					this.emailTitle = row.title; // 设置要顯示的 HTML 内容
					this.senderName = row.sender_name; // 设置要顯示的 HTML 内容
					this.sendTime = row.create_time; // 设置要顯示的 HTML 内容
				}
				
				this.dialogType = 1; // 设置要顯示的 HTML 内容
				this.is_reply = type; // 设置要顯示的 HTML 内容
				this.replyData = e; // 设置要顯示的 HTML 内容
				this.dialogVisible = true;    // 顯示对话框
				if(row.is_reply_status == 0 && type == 2){
					this.someMethod(row)
				}
				
			},
			async someMethod(row) {
				await this.changeStatus(row, 2, false, true); // 假设这是一个返回Promise的包装器
				this.getList();
			},
			closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.createReplyModel = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
				this.dialogTitle = '';      // 清空内容
			},
			 // 顯示完整標題内容
			 showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			remoteMethodSchool(query){
				if (query !== '') {
					this.loading = true;
					this.axios.post('/admin/data/getSchoolList', {
						value: query,
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						this.schoolOptions = all.data;
						this.loading = false;
					}).catch(err => {
						// 失敗
						this.schoolOptions = [];
						this.loading = false;
					})
				} else {
					this.schoolOptions = [];
					this.loading = false;
				}
			},
			changeType(){
				if(this.form.sendtype==2){
					if(this.form.all_type==1){
						
					}
				}
			},
			
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					this.user_list = all.data.list.userlist
					this.school_list = all.data.list.school
					this.user_gift = all.data.list.user_gift
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						this.submitLoading = true
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						this.closeDialog()
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e, type) {
				console.log(e)
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						title: e.title,
						content: e.content,
						appoint_id: Array.isArray(e.appoint_id) ? e.appoint_id : (e.appoint_id ? [e.appoint_id] : []),
						money:e.money,
						diamond:e.diamond,
						gift_id:e.gift_id,
						all_type:e.in_type || 4,
						email_type:e.type || 1,
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						title:'',
						content:"",
						diamond:0,
						money:0,
						gift_id:[],
						appoint_id:[],
						all_type:4,
						email_type:1,
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					email_no:'',
					content:'',
					in_name:'',
					in_type:-1,
					all_type:-1,
					reply_status:-1,
					type:-1,
					email_type:-1,
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.dialog-header {
  border-bottom: 1px solid #ebeef5;
  padding: 10px 20px;
  margin-bottom: 15px;
}

.email-info p {
  margin: 0;
  font-size: 14px;
  color: #606266;
}

.dialog-content {
  padding: 10px 20px;
}
/* 对话框整体样式 */
.custom-dialog {
  border-radius: 8px; /* 圆角边框 */
  overflow: hidden; /* 防止溢出 */
}

/* 顶部信息样式 */
.dialog-header {
  padding: 15px 20px;
  background-color: #f5f7fa; /* 添加背景色 */
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 15px;
}

.email-info p {
  margin: 0;
  color: #606266;
  font-size: 14px;
  line-height: 1.6;
}

/* 輸入框样式 */
.form-input {
  width: 100%;
  margin-bottom: 10px;
}

/* 底部按钮样式 */
.dialog-footer {
  padding: 10px 20px;
  text-align: right;
}

.dialog-footer .el-button:first-child {
  margin-right: 10px;
}

/* 改进按钮样式 */
.el-button--primary {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
}
.el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

/* 限制郵件内容高度並添加滾動條 */
.email-content {
  max-height: 100px; /* 限制高度 */
  overflow-y: auto; /* 添加垂直滾動條 */
  word-break: break-word; /* 避免內容溢出 */
  padding: 5px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #f9f9f9;
}
</style>
